import {TXY, getPoi} from "@ui/api/features"
import service from "@ui/services/features/PoiService"
import {Feature, TFeatureConstructorParams} from "./feature"
import store from "../"

type TPoiConstructorParams = TFeatureConstructorParams

export class Poi extends Feature {

  constructor(params: TPoiConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const {poi} = store
    const collection = await getPoi(coords)
    service.addPoints(collection, poi.toggle.bind(poi), poi.selected)
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
